import { Fragment } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Modal } from '@/components/settings/Modal'
import { releasesApi } from '@/lib/releasesApi'
import { ReleaseView } from './ReleaseView'
import styles from './Release.module.css'

/** Все выпуски «Что нового», свежие сверху: открывается из «Поддержки и новостей». */
export function ReleaseHistory({ onClose }: { onClose: () => void }) {
  const q = useQuery({ queryKey: ['releases', 'list'], queryFn: releasesApi.list })
  const list = q.data?.releases ?? []
  return (
    <Modal title="Что нового" onClose={onClose} width={560}>
      {q.isPending ? (
        <p className={styles.muted}>Загружаем выпуски…</p>
      ) : q.isError ? (
        <p className={styles.muted}>
          Не удалось загрузить выпуски. <button type="button" className={styles.retry} onClick={() => void q.refetch()}>Попробовать ещё раз</button>
        </p>
      ) : list.length === 0 ? (
        <p className={styles.muted}>Выпусков пока нет. Когда что-то появится, расскажем здесь.</p>
      ) : (
        <div className={styles.history}>
          {list.map((r, i) => (
            <Fragment key={r.id}>
              {i > 0 ? <hr className={styles.rule} /> : null}
              <ReleaseView title={r.title} items={r.items} publishedAt={r.published_at} />
            </Fragment>
          ))}
        </div>
      )}
    </Modal>
  )
}
